import React, { FC } from 'react';
import {
  Box,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  UseDisclosureReturn,
} from '@chakra-ui/react';

import Button from 'components/_core/Button';
import IconButton from 'components/_core/IconButton';
import Timeline from 'components/_core/Timeline';

import locales from './locales';

type ReferralHoowItWorksProps = Pick<UseDisclosureReturn, 'isOpen' | 'onClose'>;

const ReferralHowItWorksModal: FC<ReferralHoowItWorksProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
      <ModalOverlay />

      <ModalContent
        alignSelf={{ base: 'flex-end', md: 'center' }}
        borderBottomRadius={{ base: 0, md: 'radius-8' }}
        borderTopRadius={{ base: 'radius-16', md: 'radius-8' }}
        marginY={{ base: 0, md: '3.75rem' }}
      >
        <ModalHeader>
          <Flex alignItems="center" justifyContent="flex-end" width="100%">
            <IconButton
              aria-label={locales.close}
              icon="nav-close"
              onClick={onClose}
              variant="secondary"
            />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Heading marginBottom="space-8">{locales.title}</Heading>
          <Text>{locales.subtitle}</Text>
          <Box marginBottom="space-24" marginTop="space-32">
            <Timeline>
              {locales.steps.map((step) => (
                <Timeline.Step key={step}>{step}</Timeline.Step>
              ))}
            </Timeline>
          </Box>
          <a
            href="https://www.shine.fr/lp/cgu-programme-de-parrainage/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Button variant="inline-secondary">{locales.cgu}</Button>
          </a>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ReferralHowItWorksModal;
